import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TextBannerComponent} from "./text-banner.component";
import {TextModule} from "../text/text.module";
import {EvaButtonModule} from "../eva-button/eva-button.module";
import {TagTextModule} from "../tag-text/tag-text.module";
import {OptionalLinkModule} from "../optional-link/optional-link.module";



@NgModule({
  declarations: [
    TextBannerComponent
  ],
  imports: [
    CommonModule,
    TextModule,
    TagTextModule,
    EvaButtonModule,
    OptionalLinkModule
  ],
  exports: [
    TextBannerComponent
  ]
})
export class TextBannerModule { }
